import pnl3Service from '../../../services/Pnl3Service';
import CoreBase from '../../../services/engines/CoreBase';

const _name = 'Pnl3UnmatchedFetcher';

/**
 * Raw I/O for unmatched orders — no cache, no state, single responsibility.
 */
class Pnl3UnmatchedFetcher extends CoreBase {
    _name = _name;

    /**
     * @param {number|string} sid
     * @returns {Promise<object[]>}
     */
    fetch = async (sid) => {
        try {
            const res = await pnl3Service.getUnmatched(sid);
            return res?.data?.items ?? [];
        } catch (error) {
            this.logError('fetch', error.message);
            return [];
        }
    };
}

const pnl3UnmatchedFetcher = new Pnl3UnmatchedFetcher();
export default pnl3UnmatchedFetcher;
